// TODO: implement my niche add (uncomment existing functionality)
import React, { Fragment, useState } from "react";
// import { useDispatch } from "react-redux";

// import { setServerResponse } from "store/application";
import { useMyNichesQuery } from "queries";
import { NicheBrowser } from "components/niches/NicheBrowser";
import { ComboHeader } from "components/blocks/ComboHeader";
import { FeedControl } from "components/feed/FeedControl";
// import { CreateNichePopup } from "components/popups";
// import { apiNiches } from "services";
import { routes } from "routes";

import "../ExploreNichesPage/ExploreNichesPage.scss";
import { FooterAds } from "../../components/ads/FooterAds";

export const MyNichesPage = () => {
  // const dispatch = useDispatch();
  // const [showCreate, setShowCreate] = useState<boolean>(false);
  const [tiles, setTiles] = useState<boolean>(true);
  const { status, data } = useMyNichesQuery({
    previews: !tiles
  });
  const niches = data && data.niches;

  // const onCreateButton = () => {
  //   setShowCreate(true);
  // };

  // const onCreate = async (name: string) => {
  //   try {
  //     await apiNiches.createNiche({
  //       name: name,
  //     });

  //     dispatch(setServerResponse("Request sent."));
  //   } catch (e) {
  //     dispatch(setServerResponse("Request failed, please try again in few minutes."));
  //   }
  // };

  const changeMode = (mode: boolean) => {
    setTiles(mode);
  };

  return (
    <Fragment>
      <div className="wide page nichesPage">
        <ComboHeader
          back={routes.niches()}
          text="My Niches"
          // onAdd={onCreateButton}
        />

        <FeedControl
          order=""
          tiles={tiles}
          changeOrder={() => {}}
          changeMode={changeMode}
        />

        {status === "success" && niches && <NicheBrowser
          myNiche
          myWithPreview={!tiles}
          niches={niches}
        />}

        {/* <CreateNichePopup
        open={showCreate}
        onClose={() => { setShowCreate(false); }}
        onCreate={onCreate}
      /> */}
      </div>

      <FooterAds/>
    </Fragment>
  );
};
